import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  mr15: {
    marginRight: 15,
  },
  attachIcon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  name: {
    fontSize: 15,
    color: theme.custom.darkBlue,
    opacity: '.7',
    '&:hover': {
      opacity: 1,
    },
  },
}));
